// extracted by mini-css-extract-plugin
export default {"withRowClick":"BodyRow_withRowClick__yZu8Q"};